import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CareerPlanService } from "./services/careerplan.service";

import { PlanSummary, Plan } from "./models/plansummary";
import { IGuide } from "../../../employment101/guide/models/guide";
import { CommonService } from "../../services/common.service";

import * as _ from "lodash";
import { returnAtIndex } from "lodash-decorators/utils";


@Component({
  selector: 'careerplan-select',
  templateUrl: './careerplan-select.component.html',
  providers: [CareerPlanService, CommonService]
})
export class CareerPlanSelectComponent {

  @Input()
  guide: IGuide;


  @Input()
  selectPlan: string = '';

  @Input()
  showNew: boolean = false;

  @Output()
  changed: EventEmitter<any> = new EventEmitter();



  careerPlanUrl: string = "";
  planSummary: PlanSummary = {} as PlanSummary;

  selectedPlan: Plan;

  defaultPlan: string = "ba17e09f-0019-4cb4-91e5-0986855fb5e8";
  careerPlanId: string = '';
  returnUrl: string;

  saving: boolean = false;


  constructor(private careerPlanService: CareerPlanService, private commonService: CommonService) { }

  ngOnInit() {

    this.loadPlans();

  }

  loadPlans() {

    this.commonService.baseSite().subscribe(baseUrl => {

      let base = _.trimEnd(baseUrl, '/');
      this.returnUrl = base + `/employment101/?selectPlan=` + this.defaultPlan;

    });


    this.careerPlanService.getPlanStepSummary()
      .subscribe(res => {
        console.log('Plan Summary', res);

        this.planSummary = res;

        if (this.planSummary.plans.length == 0) {
          this.careerPlanId = "New";
        } else if (this.planSummary.plans.length == 1) {
          this.careerPlanId = this.planSummary.plans[0].projectGuid;
        } else {
          this.careerPlanId = this.guide.careerPlanId;
        }

        if (this.selectPlan != null && this.selectPlan != '') {
          this.careerPlanId = this.selectPlan;
          this.setPlan();
        }
      });

    this.careerPlanService.getCreateCareerPlanUrl()
      .subscribe(res => {

        this.careerPlanUrl = res;

        console.log('Career Plan URL', res);

      });
  }

  showNewOption() {


    if (this.planSummary.plans != null && this.planSummary.plans.filter(f => f.projectGuid == this.defaultPlan).length <= 0) {
      return true;
    }

    return false;
  }

  setPlan() {

    this.saving = true;

    console.log("Career Plan ID:", this.careerPlanId)

    if (this.careerPlanId == 'New') {
      var url = this.careerPlanUrl + this.guide.userId + "?projectId=" + this.defaultPlan + "&returnUrl=" + this.returnUrl;
      console.log(url);

      window.location.href = url

    } else {
      let project = this.planSummary.plans.filter(f => f.projectGuid == this.careerPlanId)[0];

      //Update E101 with the plan
      this.careerPlanService.updateCareerPlan(this.guide.id, this.careerPlanId, project.projectName).subscribe(res => {
        
        //Output change
        this.changed.emit(null);
      });   
    }        
  }

}
